// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  dashStartedAt: __t.timestamp().name("dash_started_at"),
  guardRaisedAt: __t.timestamp().name("guard_raised_at"),
  guardReleasedAt: __t.timestamp().name("guard_released_at"),
  parryWindowMs: __t.u32().name("parry_window_ms"),
  lastParryAt: __t.timestamp().name("last_parry_at"),
  lastLandedAt: __t.timestamp().name("last_landed_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
